import {connect} from 'react-redux';
import {constant, get} from 'lodash/fp';
import {createStructuredSelector} from 'reselect';

import {ENABLE_STORYBOOK} from '/config/storybook.config';
import {ENABLE_TESTING_OPTIONS} from '/config/testingOptions.config';
import {withStorybook} from '/provider/StorybookProvider';
import {signOut} from '/redux/action/auth.action';
import {
  getHealthcareData,
  getLeadsPool,
  getProfile,
  getSupportedLanguages,
  getTeams,
} from '/redux/action/coach.action';
import {
  fullNameById,
  hasHealthcareData,
  hasHealthcareError,
  hasLeadsPool,
  hasLeadsPoolError,
  hasProfileById,
  hasSupportedLanguages,
  hasSupportedLanguagesError,
  hasTeamsById,
  paidAsRankDescLastMonth,
  teamsHasMentorsById,
} from '/redux/selector/coach.selector';
import {userId} from '/redux/selector/currentUser.selector';
import {currentScreen} from '/redux/selector/navigation.selector';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {generateCallback} from '/util/component.util';
import {fromProps, withProps} from '/util/selector.util';

import Profile from './Profile';

const withCoachId = withProps({
  coachId: fromProps(get('userId')),
});

export default connect(
  createStructuredSelector({
    userId,
    hasProfile: withCoachId(hasProfileById),
    hasTeams: withCoachId(hasTeamsById),
    hasMentors: withCoachId(teamsHasMentorsById),
    coachName: withProps({coachId: userId})(fullNameById),
    showStorybook: constant(ENABLE_STORYBOOK),
    showTestingOptions: constant(ENABLE_TESTING_OPTIONS),
    currentScreen,
    lastPaidRank: withProps({coachId: userId})(paidAsRankDescLastMonth),
    featureFlag: variablesFeatureFlag,

    hasLeadsPool,
    hasSupportedLanguages,
    hasHealthcareData,
    leadsPoolError: hasLeadsPoolError,
    supportedLanguagesError: hasSupportedLanguagesError,
    healthcareError: hasHealthcareError,
  }),
  (dispatch: any) => {
    const typedDispatch = dispatch as any;

    return {
      getProfile: ({coachId}: any) => typedDispatch(getProfile({coachId})),
      getTeams: ({coachId}: any) => typedDispatch(getTeams({coachId})),
      getLeadsPool: () => typedDispatch(getLeadsPool({})),
      getSupportedLanguages: () => typedDispatch(getSupportedLanguages({})),
      getHealthcareData: () => typedDispatch(getHealthcareData({})),
      // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
      signOut: generateCallback({func: dispatch, params: signOut()}),
    };
  },
  (stateProps, dispatchProps, ownProps) => {
    const {
      hasProfile,
      hasTeams,
      hasLeadsPool,
      hasSupportedLanguages,
      hasHealthcareData,
      leadsPoolError,
      supportedLanguagesError,
      healthcareError,
    } = stateProps;

    const {userId: coachId} = ownProps;

    const hasData =
      hasProfile &&
      hasTeams &&
      (hasLeadsPool || !!leadsPoolError) &&
      (hasSupportedLanguages || !!supportedLanguagesError) &&
      (hasHealthcareData || !!healthcareError);

    return {
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      hasData,
      fetchData: () => {
        if (!hasProfile) {
          dispatchProps.getProfile({coachId});
        }

        if (!hasTeams) {
          dispatchProps.getTeams({coachId});
        }

        if (!hasLeadsPool && !leadsPoolError) {
          dispatchProps.getLeadsPool();
        }

        if (!hasSupportedLanguages && !supportedLanguagesError) {
          dispatchProps.getSupportedLanguages();
        }

        if (!hasHealthcareData && !healthcareError) {
          dispatchProps.getHealthcareData();
        }
      },
    };
  },
)(withStorybook(Profile));
